import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React from 'react';
import Select from 'react-select';
import { BrandSwitch } from '../../../components/BrandSwitch';
import { Fieldset, Field, Label } from '../../../components/fieldset';
import { Input, InputGroup } from '../../../components/input';
import { reactSelectReset } from '../../../utils/utils';

const sortByOptions = [
  // { value: '', label: '' },
  { value: 'title', label: 'Opportunity Name' },
  { value: 'facility__name', label: 'Facility Name' },
  { value: 'facility__state', label: 'Facility State' },
  { value: 'specialty', label: 'Specialty' },
  { value: 'current_status__title', label: 'Status' },
];

const sortDirectionOptions = [
  { value: '', label: 'Ascending' },
  { value: '-', label: 'Descending' },
];

interface OpportunityFiltersProps {
  search: string;
  onSearchChange: (value: string) => void;
  sortBy: string;
  onSortByChange: (value: string) => void;
  sortDirection: string;
  onSortDirectionChange: (value: string) => void;
  showClosed: boolean;
  onShowClosedChange: (value: boolean) => void;
}

const OpportunityFilters: React.FC<OpportunityFiltersProps> = ({
  search,
  onSearchChange,
  sortBy,
  onSortByChange,
  sortDirection,
  onSortDirectionChange,
  showClosed,
  onShowClosedChange,
}) => {
  return (
    <div
      id="search-filters-section"
      className="tw:bg-white tw:rounded-lg tw:shadow-sm tw:border tw:border-zinc-200 tw:py-3 tw:px-4 tw:dark:bg-zinc-700 tw:dark:border-zinc-400"
    >
      <Fieldset className="tw:grid tw:grid-cols-1 tw:md:grid-cols-2 tw:lg:grid-cols-3 tw:gap-4 tw:mb-4">
        {/* Search Box */}
        <Field>
          <Label htmlFor="search-input">Search Opportunities</Label>
          <InputGroup>
            <MagnifyingGlassIcon data-slot="icon" />
            <Input
              id="search-input"
              type="text"
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </InputGroup>
        </Field>
        {/* Sort By */}
        <Field>
          <Label htmlFor="sort-by-select">Sort By</Label>
          <Select
            id="sort-by-select"
            options={sortByOptions}
            value={sortByOptions.find((opt) => opt.value === sortBy) || null}
            onChange={(option) => onSortByChange(option?.value || '')}
            placeholder="Select sort field"
            className="tw:w-full"
            styles={reactSelectReset}
          />
        </Field>
        {/* Sort Direction */}
        <Field>
          <Label htmlFor="sort-direction-select">Sort Direction</Label>
          <Select
            id="sort-direction-select"
            options={sortDirectionOptions}
            value={sortDirectionOptions.find((opt) => opt.value === sortDirection) || null}
            onChange={(option) => onSortDirectionChange(option?.value || '')}
            placeholder="Select direction"
            className="tw:w-full"
            styles={reactSelectReset}
          />
        </Field>
        {/* Show Closed Toggle */}
        <Field className="tw:flex tw:items-center tw:gap-2">
          <BrandSwitch checked={showClosed} onChange={onShowClosedChange} id="show-closed-switch" />
          <Label htmlFor="show-closed-switch">Show Closed</Label>
        </Field>
      </Fieldset>
    </div>
  );
};

export default OpportunityFilters;
